<template>
  <div>
    <form class="auth-form" @submit.prevent="login">
      <base-logo-wave class="text-center auth-logo" />

      <h2 class="text-uppercase">{{ $t('auth.login.title') }}</h2>

      <google-login-button intent="login" />

      <div class="d-flex justify-content-center align-items-center mt-2 mb-2">
        <p class="my-1">{{ $t('auth.login.login_option_divider') }}</p>
      </div>

      <base-button
        v-if="!mail_login"
        type="button"
        class="mail-login-btn btn-block btn-sm"
        @click.native="mail_login = !mail_login">
        {{ $t('auth.login.login_with_mail_btn') }}
      </base-button>

      <base-input
        v-if="mail_login"
        v-model="loginData.email"
        type="email"
        class="mt-2"
        :placeholder="$t('auth.login.email_placeholder')"
        required
        autofocus
      />

      <base-input
        v-if="mail_login"
        v-model="loginData.password"
        type="password"
        :placeholder="$t('auth.login.password_placeholder')"
        required
      />

      <!--<base-button type="submit" class="btn-block btn-lg" :disabled="!loginData.turnstile_token">-->

      <b-row class="mt-2" v-if="mail_login">
        <b-col cols="6">
          <base-checkbox v-model="loginData.remember_me">
            {{ $t('auth.login.remember_me_checkbox') }}
          </base-checkbox>
        </b-col>
        <b-col  cols="6" class="text-right">
          <router-link :to="{ name: 'forgot-password' }">
            {{ $t('auth.login.forgot_password') }}
          </router-link>
        </b-col>
      </b-row>

       <base-button type="submit" class="btn-block btn-lg" v-if="mail_login">
        {{ $t('auth.login.login_btn') }}
      </base-button>

      <!--<div class="text-center mb-1">
        <div id="turnstile-container"></div>
      </div>
      -->

      <p class="bottom-text text-center">
        {{ $t('auth.login.dont_have_an_account') }}
        &nbsp;<router-link :to="{ name: 'sign-up' }">{{ $t('auth.login.sign_up') }}</router-link>

        <br>

        {{ $t('auth.login.did_not_receive_confirmation_instructions') }}
        &nbsp;<router-link :to="{ name: 'resend-confirmation-instructions' }">{{ $t('auth.login.resend_confirmation_instructions') }}</router-link>
      </p>
    </form>
  </div>
</template>

<script>
import BaseLogoWave from '../../components/BaseLogoWave.vue'
import BaseInput from '../../components/BaseInput.vue'
import BaseCheckbox from '../../components/BaseCheckbox.vue'
import BaseButton from '../../components/BaseButton.vue'
import GoogleLoginButton from '../../components/GoogleLoginButton.vue'

export default {
  data () {
    return {
      loginData: {
        email: '',
        password: '',
        remember_me: false,
        turnstile_token: ''
      },
      mail_login: false,
      env: {
        turnstile_site_key: process.env.VUE_APP_TURNSTILE_SITE_KEY,
        google_omniauth_url: process.env.VUE_APP_GOOGLE_OMNIAUTH_URL,
        google_client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID
      }
    }
  },
  components: {
    GoogleLoginButton,
    BaseLogoWave,
    BaseInput,
    BaseCheckbox,
    BaseButton
  },
  mounted () {
    if (this.$route.query.account_confirmation_success === 'true') {
      this.$notify({
        type: 'success',
        text: this.$t('auth.confirmations.confirmed')
      })
    }

    // eslint-disable-next-line no-undef
    // turnstile.render('#turnstile-container', {
    //  sitekey: this.env.turnstile_site_key,
    //  callback: (token) => {
    //    this.loginData.turnstile_token = token
    //  }
    // })
  },
  methods: {
    async login () {
      await this.$recaptchaLoaded()
      this.$Progress.start()

      this.$recaptcha('login').then(token => {
        this.$auth.login({
          data: this.loginData,
          fetchUser: true,
          staySignedIn: true
        }).then(() => {
          this.$auth.load().then(() => {
            if (this.$auth.check()) {
              this.$store.dispatch('profile/account/loadCurrentUser')
            }

            // Profile completion is currently not required. Kept for possible later use.
            // if (!this.$auth.user().profile_completed) {
            //   this.$router.push({ name: 'profile.account' })
            //
            //   this.$notify({
            //     type: 'warn',
            //     text: this.$t('profile.account.update_your_account_data')
            //   })
            // } else if (this.$auth.user().subscriptions.length > 0) {
            if (this.$auth.user().subscriptions.length > 0) {
              this.$router.push({ name: `${this.$auth.user().subscriptions[0].markets[0].slug}.instruments` })
            }
          })

          this.$Progress.finish()
        }, (error) => {
          this.$Progress.finish()
          this.loginData.password = ''

          this.$notify({
            type: 'error',
            text: this.devise().formatResponse(error.response.data) || this.$t('common.unknown_error')
          })

          // this.loginData.turnstile_token = ''

          // if (window.turnstile) {
          //  window.turnstile.reset()
          // }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
h2 {
  font-size: 14px;
  color: var(--cool-grey);
  margin-bottom: 20px;
}
</style>
